import React from "react";

import { useViewport } from "js/hooks/useViewport";
import breakpoints from "core/breakpoints";
import { convertPxToRem } from "frontend/components/helpers";

import {
    GridItemContentDisplay as CoreGridItemContentDisplay,
    Image
} from "frontend/components/core/Grid2/GridItemContentTemplates/Display/index.js";

// if uploads have these values, the thumbnails should be hidden because they
// may contain harmful imagery
const HIDDEN_STATUS_VALUES = [
    "DENIED_AUTO",
    "AUTO_DENIED_BATCH_HAS_BANNED_IMAGERY"
];

const shouldHideThumbnail = d => {
    const deniedStatusValues = [];
    // equivalent to status = DENIED_AUTO, but checking in case status not fetched
    if (d.autoDenied) {
        return true;
    }
    if (HIDDEN_STATUS_VALUES.includes(d.status)) {
        return true;
    }
    return false;
};

export const generateGridItemContent = ({
    gridItemData,
    testId = "grid-item-image"
}) => {
    const gridItemCount = gridItemData.length;

    return gridItemData.map((d, index) => (
        <CoreGridItemContentDisplay
            key={d.originalFilename}
            id={index}
            name={d.originalFilename}
            gridIndex={index}
            gridItemCount={gridItemCount}
        >
            <Image
                name={d.originalFilename}
                imageSrc={d.thumbnail}
                imgTestId={`${testId}-${index}`}
                showPhotoIcon={shouldHideThumbnail(d)}
            />
        </CoreGridItemContentDisplay>
    ));
};

export const useSubmissionGridItems = () => {
    const { browserWidth } = useViewport();
    const isMobile = browserWidth <= breakpoints.beforeTablet.px;
    const isTablet =
        browserWidth > breakpoints.beforeTablet.px &&
        browserWidth < breakpoints.desktop.px;

    let numberOfColumns = 5;

    if (isTablet) numberOfColumns = 3;
    if (isMobile) numberOfColumns = 1;

    const gridSpacingSize = convertPxToRem({ px: isMobile ? 16 : 24 });

    return {
        numberOfColumns,
        gridSpacingSize
    };
};
